var _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgAyudaFull(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "24px",
    height: "24px",
    viewBox: "0 0 24 24",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Ico / Bottom Nav / large / ayuda-full") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Ico-/-Bottom-Nav-/-large-/-ayuda-full",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M12.0001,2.0005 C17.5221,2.0005 22.0001,6.4775 22.0001,12.0005 C22.0001,17.5225 17.5221,22.0005 12.0001,22.0005 C6.4771,22.0005 2.0001,17.5225 2.0001,12.0005 C2.0001,6.4775 6.4771,2.0005 12.0001,2.0005 Z M11.7881,17.0025 C11.4491,17.0025 11.1931,17.0995 11.0211,17.2935 C10.8491,17.4865 10.7621,17.7255 10.7621,18.0105 C10.7621,18.2965 10.8491,18.5325 11.0211,18.7185 C11.1931,18.9065 11.4491,19.0005 11.7881,19.0005 C12.1271,19.0005 12.3851,18.9065 12.5611,18.7185 C12.7351,18.5325 12.8231,18.2965 12.8231,18.0105 C12.8231,17.7255 12.7351,17.4865 12.5611,17.2935 C12.3851,17.0995 12.1271,17.0025 11.7881,17.0025 Z M12.0521,5.0005 C10.9091,5.0005 9.9821,5.3125 9.2701,5.9365 C8.6611,6.4705 8.3081,7.1475 8.2101,7.9675 C8.1831,8.1985 8.3801,8.3985 8.6121,8.3985 L8.6121,8.3985 L9.5331,8.3985 C9.7301,8.3985 9.9181,8.2655 9.9471,8.0695 C10.0101,7.6495 10.1961,7.3045 10.5081,7.0335 C10.8961,6.6945 11.4111,6.5255 12.0521,6.5255 C12.7111,6.5255 13.2131,6.7115 13.5581,7.0835 C13.9031,7.4575 14.0761,7.9715 14.0761,8.6295 C14.0761,9.3115 13.8131,9.9515 13.2851,10.5455 L13.2851,10.5455 L12.0521,11.8145 C11.5681,12.3405 11.2481,12.8205 11.0921,13.2525 C10.9661,13.6005 10.8861,14.0485 10.8541,14.5975 C10.8401,14.8255 11.0271,15.0195 11.2551,15.0195 L11.2551,15.0195 L12.1981,15.0195 C12.4121,15.0195 12.5771,14.8465 12.5921,14.6345 C12.6471,13.8685 12.8721,13.2665 13.2661,12.8295 L13.2661,12.8295 L14.2921,11.8145 C15.3091,10.7495 15.8171,9.6685 15.8171,8.5715 C15.8171,7.4625 15.4861,6.5905 14.8241,5.9545 C14.1621,5.3175 13.2381,5.0005 12.0521,5.0005 Z",
    id: "Fill-1",
    fill: "#000000"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAyudaFull);
export default __webpack_public_path__ + "static/media/ayuda-full.29e039190aef6e1d450d99eea1df7a00.svg";
export { ForwardRef as ReactComponent };